// Styles for AccountContainer go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledAccountContainer = styled.div<{ isAccountModal?: boolean }>`
  .overlay-msg-content {
    max-width: 100% !important;
  }
  .reslookup-theme {
    background-color: ${baseVariables.color.neutral20};
  }
  .account-page-error-msg {
    .m-message-content {
      p {
        margin-bottom: 0;
      }
    }
  }
  .custom-padding {
    &:nth-child(1) {
      padding-right: ${toRem(8)} !important;
      @media ${baseVariables.mediaQuery.lg} {
        padding-right: ${toRem(64)} !important;
      }
    }

    &:nth-child(2) {
      padding-left: ${toRem(8)} !important;
      @media ${baseVariables.mediaQuery.lg} {
        padding-left: ${toRem(64)} !important;
      }
    }
  }
  .custom-padding-overlay {
    &:nth-child(1) {
      padding-right: ${toRem(8)} !important;
      @media ${baseVariables.mediaQuery.md} {
        padding-right: ${toRem(32)} !important;
      }
      @media ${baseVariables.mediaQuery.lg} {
        padding-right: ${toRem(64)} !important;
      }
    }
    &:nth-child(2) {
      padding-left: ${toRem(8)} !important;
      @media ${baseVariables.mediaQuery.md} {
        padding-left: ${toRem(40)} !important;
      }
      @media ${baseVariables.mediaQuery.lg} {
        padding-left: ${toRem(64)} !important;
      }
    }
  }
  .border-left {
    &:nth-child(2) {
      border-top: ${toRem(1)} solid ${baseVariables.color['neutral30']};
      @media ${baseVariables.mediaQuery.lg} {
        border-left: ${toRem(1)} solid ${baseVariables.color['neutral30']};
        border-top: none;
      }
    }
  }
  .border-left-overlay {
    &:nth-child(2) {
      border-top: ${toRem(1)} solid ${baseVariables.color['neutral30']};
      @media ${baseVariables.mediaQuery.md} {
        border-left: ${toRem(1)} solid ${baseVariables.color['neutral30']};
        border-top: none !important;
      }
    }
  }
  .custom-padding-overlay {
    &:nth-child(1) {
      padding-right: ${toRem(8)} !important;
      @media ${baseVariables.mediaQuery.md} {
        padding-right: ${toRem(32)} !important;
      }
      @media ${baseVariables.mediaQuery.lg} {
        padding-right: ${toRem(64)} !important;
      }
    }
    &:nth-child(2) {
      padding-left: ${toRem(8)} !important;
      @media ${baseVariables.mediaQuery.md} {
        padding-left: ${toRem(32)} !important;
      }
      @media ${baseVariables.mediaQuery.lg} {
        padding-left: ${toRem(64)} !important;
      }
    }
  }
  .border-left {
    &:nth-child(2) {
      border-top: ${toRem(1)} solid ${baseVariables.color['neutral30']};
      @media ${baseVariables.mediaQuery.lg} {
        border-left: ${toRem(1)} solid ${baseVariables.color['neutral30']};
        border-top: none;
      }
    }
  }
  .border-top-flyout {
    &:nth-child(2) {
      border-top: ${toRem(1)} solid ${baseVariables.color['neutral30']};
    }
  }
  .border-left-overlay {
    &:nth-child(2) {
      border-top: ${toRem(1)} solid ${baseVariables.color['neutral30']};
      @media ${baseVariables.mediaQuery.md} {
        border-left: ${toRem(1)} solid ${baseVariables.color['neutral30']};
        border-top: none;
      }
    }
  }
  .change-password-form {
    padding-left: ${toRem(24)} !important;
    padding-right: ${toRem(24)} !important;
    @media ${baseVariables.mediaQuery.md} {
      padding-left: ${toRem(40)} !important;
      padding-right: ${toRem(40)} !important;
    }
  }
`;

export const StyledFlyoutDrawerContainerDiv = styled.div`
  .back-cta {
    width: 100%;
    background-color: ${baseVariables.color.neutral20};
    text-align: left;
  }
  .spinner-wrapper {
    min-height: ${toRem(500)};
    @media ${baseVariables.mediaQuery.md} {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .spinner-loader {
    height: ${toRem(64)};
    width: ${toRem(64)};
  }
  .error-icon {
    font-size: ${toRem(70)};
    color: ${baseVariables.color['alert40']};
  }
`;

export const StyledAccountContainerV2Div = styled.div``;

export const StyledModalAccountContainerDiv = styled.div`
  > div[class*='Modal'] {
    overflow-y: scroll;
    &:before {
      position: fixed;
      @media ${baseVariables.mediaQuery.md} {
        right: ${toRem(4)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        right: ${toRem(16)};
      }
    }
  }
  .account-container-modal {
    &.show {
      @media ${baseVariables.mediaQuery.lg} {
        display: flex;
      }
    }
    .account-container-modal-secondary {
      max-width: 100%;
      @media ${baseVariables.mediaQuery.md} {
        max-width: ${toRem(584)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        max-width: ${toRem(1124)};
      }
      width: 100%;
      .modal-header {
        height: auto;
        border-bottom: 0;
        position: relative;
        .dtt-popup-close {
          visibility: hidden;
          animation: delayclose 1s forwards;
          animation-delay: 5s;
          @keyframes delayclose {
            0% {
              visibility: hidden;
            }
            100% {
              visibility: visible;
            }
          }
        }
        .popup-close {
          cursor: pointer;
          right: ${toRem(32)};
          top: ${toRem(35)};
          @media ${baseVariables.mediaQuery.lg} {
            position: absolute;
            z-index: 2;
          }
        }
      }
      .modal-body {
        max-height: 80vh;
        @media ${baseVariables.mediaQuery.md} {
          max-height: 90vh;
        }
        @media ${baseVariables.mediaQuery.lg} {
          padding: ${toRem(64)} !important;
          max-height: auto;
        }
      }
    }
  }
`;
